export type ProductVersion = "app_old" | "2022" | "2024" | "2025";
export const productVersions: Record<ProductVersion, number> = {
  "app_old": 0,
  "2022": 1,
  "2024": 2,
  "2025": 3,
}
export class Pvi {
  static get(version: ProductVersion | undefined): number {
    if (!version)
      return 0;
    return productVersions[version] || 0;
  }

  static is(version: ProductVersion | { version: ProductVersion } | undefined, other: ProductVersion): boolean {
    return Pvi.get(typeof version === "object" ? version.version : version) >= Pvi.get(other);
  }

  static eq(version: ProductVersion | { version: ProductVersion } | undefined, other: ProductVersion): boolean {
    return Pvi.get(typeof version === "object" ? version.version : version) === Pvi.get(other);
  }
}